import { createFileRoute, redirect } from "@tanstack/react-router";

import { client } from "@/api/client";
import { sdk } from "@/api/sdk";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/logout/")({
  staticData: { sitemap: false },
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.auth_logout_crumb(),
    };
  },

  beforeLoad: async () => {
    await sdk.auth.logout.$get.send();
    client.cache.delete(sdk.users.me.$get.cacheKey);
    client.cache.invalidate(/\/users\/me/);
    await client.cache.clear();

    throw redirect({ to: "/login" });
  },
});

function RouteComponent() {
  return <></>;
}
